import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { formfileHandle } from "@/utils/utils";
let _ = require('lodash');
export default {
  name: 'typedatav2',
  props: {
    form: {
      type: Object,
      default: {}
    },
    formlabel: {
      type: Object,
      default: {}
    },
    formoption: {
      type: Object,
      default: {}
    },
    formfield: {
      type: Object,
      default: {}
    },
    isadd: {
      type: Boolean,
      default: true
    },
    mapoptions: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      typeshow: false,
      dialogVisible: false,
      tableData: [],
      parentIcon: [],
      childIndex: '',
      childIcon: []
    };
  },
  watch: {
    isadd(val) {
      console.log(`isadd`, val);
      if (val) this.reset();
    },
    form(val) {
      console.log(`this.typeform`, this.form);
      if (Object.keys(val).length > 0) {
        val.children = val.json ? [...JSON.parse(val.json.replace(/(<\/?p.*?>)/gi, ''))] : [];
        val.isMultilevel = val.children.length > 0 ? true : false;
        this.parentIcon = this.form.icon === '' || this.form.icon === undefined ? [] : _.cloneDeep(this.form.icon);
      }
    }
  },
  methods: {
    typeopen() {
      // this.typeshow = true
      this.dialogVisible = true;
    },
    typeclose() {
      // this.typeshow = false
      this.reset();
      this.dialogVisible = false;
    },
    reset() {
      console.log(`resetFields`);
      this.$refs['formdata'].resetFields();
      console.log(`this.form`, this.form);
    },
    fileListHandle(val, type) {
      console.log(val);
      console.log(type);
      if (type.includes('rowicon')) {
        let iconIndex = Number(type.replace('rowicon', ''));
        console.log(iconIndex);
        this.form.children.forEach((elem, index) => {
          if (iconIndex === index) elem.icon = formfileHandle(val, 'imagebox', this.$route.query.uid);
        });
      } else {
        this.parentIcon = val;
      }
      console.log(this.form);
    },
    /**
     * 选择地图
     */
    mapchange(val) {
      this.form.onlyid = val;
    },
    /**
     * 是否多级改变操作
     */
    multilvelChange(val) {
      console.log(this.form.children);
      if (this.form.children.length === 0) {
        this.form.children = [{
          title: '',
          icon: []
        }];
      }
    },
    /**
     * 添加行
     */
    addRow(index) {
      this.form.children.push({
        title: '',
        icon: []
      });
    },
    /**
     * 删除行
     */
    deleteRow(index) {
      this.form.children.splice(index, 1);
    },
    /**
     * 保存操作
     */
    savetypeHandle() {
      this.$refs['formdata'].validate(valid => {
        if (valid) {
          const formdata = _.cloneDeep(this.form);
          formdata.icon = this.parentIcon;
          console.log(`formdata`, formdata);
          this.$emit('submit', formdata);
        }
      });
    },
    /**
     * 打开素材库
     * @param {Object} child 分类子项
     * @param {Number} childIndex 分类子项索引
     * @date 2025-06-17
     */
    openSourceMaterial(type, child, childIndex) {
      let obj = {
        type: type,
        title: '图标库'
      };
      if (childIndex !== undefined) {
        this.childIndex = childIndex;
        if (child.icon.length > 0) obj.pic = child.icon;
      } else {
        this.childIndex = '';
        if (this.parentIcon.length > 0) obj.pic = this.parentIcon;
      }
      this.$emit('openSource', obj);
    },
    /**
     * 选中素材回调事件
     * @param {Object} data 数据
     * @date 2025-06-17
     */
    changePic(data) {
      console.log(`data`, data);
      if (data.picture_upload.length > 0) {
        if (this.childIndex === '') {
          this.parentIcon = data.picture_upload;
        } else {
          this.form.children.forEach((child, index) => {
            if (index === this.childIndex) child.icon = data.picture_upload;
          });
        }
      }
    }
  }
};